import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeCartItem, setCartItems, updateCartItem } from '../../store/cartItems';
import icons from '../../utils/icons.json';
import { useSelector } from 'react-redux';
import { setToStore, num2Thousand } from '../../utils/fn';
import img from '../../assets/product-placeholder.png';
import { setAlert } from '../../store/alert';
import { motion } from 'framer-motion';


function CartItem({ data: product }) {
	const dispatch = useDispatch();
	const cartItems = useSelector(state => state.cartItems.data);
	const webSettings = useSelector(state => state.webSettings.data);
	const [updating, setUpdating] = useState(false);
	const [removing, setRemoving] = useState(false);

	useEffect(() => {
		setToStore('cart-items', cartItems);
	}, [cartItems]);

	function removeFromCart() {
		setRemoving(true);
		dispatch(removeCartItem(product.item_code));
		setRemoving(false);
		dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
	}

	function updater(quantity) {
		if (product.closing >= quantity) {
			if (removing || updating || quantity === product.quantity) {
				// we will alert something here for the user
				return;
			}
			setUpdating(true);
			dispatch(updateCartItem({ ...product, quantity }));
			setUpdating(false);
		} else {
			dispatch(setAlert({ type: 'error', message: 'Item Out of stock' }));
		}
	}

	const productprice = product?.promotion_price > 0 ? product.promotion_price : product.price


	return (
		<motion.div layout className='cart-item'>
			<div className='flex sec-1'>
				<section className='image' style={{ backgroundImage: `url(${product.src[0] || img})` }}></section>
				<section className='details'>
					<p className='name'>{product.item_name}</p>
					<div className='view-quantity'>
						<p>Quantity</p>
						<div className='btn-group'>
							<button type='button' onClick={() => updater(product.quantity > 1 ? product.quantity - 1 : 1)} dangerouslySetInnerHTML={{ __html: icons.minus }}></button>
							{updating && <span dangerouslySetInnerHTML={{ __html: icons.btn_spinner }}></span>}
							{!updating && <input value={product.quantity} type='number' min='1' step='1' onInput={e => updater(parseInt(e.target.value) || 1)} />}
							<button type='button' onClick={() => updater(product.quantity + 1)} dangerouslySetInnerHTML={{ __html: icons.plus }}></button>
						</div>
					</div>
				</section>
			</div>
			<div className='flex sec-2'>
				{removing && <section className='flex' dangerouslySetInnerHTML={{ __html: icons.btn_spinner + '<span style="color: red; margin-left: 10px">removing</span>' }}></section>}
				{!removing && <button onClick={removeFromCart} className='btn-remove flex' dangerouslySetInnerHTML={{ __html: icons.trash + 'Remove' }}></button>}
				<table>
					<tbody>
						<tr>
							<td>Unit Price:</td>
							<td>
								{webSettings.CURRENCY} {productprice}
							</td>
						</tr>
						<tr>
							<th>Sub Total:</th>
							<th>
								{webSettings.CURRENCY} {num2Thousand((parseFloat(productprice) * product.quantity).toFixed(2))}
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		</motion.div>
	);
}

export default React.memo(CartItem);
